module.exports = __webpack_public_path__ + "static/img/jishu.d3982c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/jishu.png
// module id = SIHx
// module chunks = 12